import { render, staticRenderFns } from "./AllHistory.vue?vue&type=template&id=2207fcc5"
import script from "./AllHistory.vue?vue&type=script&lang=js"
export * from "./AllHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2207fcc5')) {
      api.createRecord('2207fcc5', component.options)
    } else {
      api.reload('2207fcc5', component.options)
    }
    module.hot.accept("./AllHistory.vue?vue&type=template&id=2207fcc5", function () {
      api.rerender('2207fcc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/WMS/waveDetail/AllHistory.vue"
export default component.exports